module.exports = __webpack_public_path__ + "img/swirl.56e61712.png";